import {
  ADD_ATTACHMENT_DIGISIGN,
  ADD_DOCUMENT_DIGISIGN,
  DELETE_ATTACHMENT_DIGISIGN,
  DELETE_DETAIL_COURSE_DIGISIGN,
  DELETE_PENOMORAN_PERIZINAN,
  GET_DETAIL_COURSE_DIGISIGN,
  GET_DETAIL_DIGISIGN,
  GET_DETAIL_SERTIFIKAT_EXTERNAL,
  GET_LIST_APPROVAL_SK,
  GET_LIST_COMPLETED,
  GET_LIST_COMPOSER,
  GET_LIST_COURSE_DIGISIGN,
  GET_LIST_DRAFT,
  GET_LIST_INPROGRESS,
  GET_LIST_NEEDSIGN_SK,
  GET_LIST_READY,
  GET_OPTION_PYB,
  GET_OPTION_PYB_PPID,
  GET_OPTION_PYB_PK,
  GET_PENERIMA_SERTIF_DIGISIGN,
  GET_PENOMORAN_PERIZINAN,
  GET_PERIZINAN_ESEA_COUNT,
  GET_REJECTED_DIGISIGN,
  GET_RETRY_DIGISIGN,
  GET_SERTIFIKAT_EXTERNAL,
  GET_SIGNED_DIGISIGN,
  GET_SUBJECT_LIST,
  GET_SUMMARY_COUNT,
  GET_SUMMARY_LIST,
  GET_TEMPLATE_DIGISIGN,
  ONCHANGE_STATE_FILTER,
  RESET_DIGISIGN,
  GET_TRACK_DIGISIGN,
  GET_PERIZINAN_PKRL_COUNT,
  GET_PERIZINAN_PKRL_DASHBOARD,
  GET_LIST_INBOX_PK,
  GET_MONITORING_DASHBOARD,
  GET_LIST_DOKUMEN_LPMUKP,
  GET_DETAIl_DOKUMEN_LPMUKP,
  CHANGE_FILTER_PLPMUKP,
  GET_DASHBOARD_SK,
  GET_DASHBOARD_COUNT_DOKUMEN,
  GET_DIGISIGN_COUNT,
  ADD_CSV_TO_JSON_DIGISIGN,
  GET_REVISI_DIGISIGN,
  GET_SIAPMUTU_COUNT,
  GET_LIST_NUMBER,
  GET_LIST_REVISION,
  RESET_LIST_RECEIVERS_DIGISIGN,
  GET_TEMPLATE_RECEIVERS_BANKOM,
} from 'shared/constants/ActionTypes';

const initialState = {
  draft: null,
  detail: null,
  lists: null,
  courses: null,
  detailCourse: null,
  filter: 'composer',
  filterProdukLPMUKP: 'draft',
  attachment: [],
  summaryCount: null,
  summaryList: null,
  subjectList: null,
  templateList: null,
  dashboardSk: null,
  optionPYB: [],
  optionPYBPPID: [],
  optionPYBPK: [],
  listPenerimaSertif: [],
  listSertifikatExternal: null,
  detailSertifikatExternal: null,
  perizinanEseaCount: null,
  nomorPerizinan: '',
  perizinanPKRLCount: null,
  perizinanPKRLDashboard: null,
  siapMutuCount: null,
  monitoringDashboard: null,
  dokumenDashboard: {
    count: {
      belumDiproses: 0,
      sedangDiproses: 0,
      sudahDiproses: 0,
    },
    dataChart: [],
    dataCompare: [],
  },
  digisignCount: {
    need_sign: 0,
    done: 0
  },
  templateReceiversBankom: [],
};

const digitalSignReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_LIST_DRAFT:
      return {
        ...state,
        lists: action.payload,
      };
    case GET_LIST_COMPOSER:
      return {
        ...state,
        lists: action.payload,
      };
    case GET_LIST_INPROGRESS:
      return {
        ...state,
        lists: action.payload,
      };
    case GET_LIST_INBOX_PK:
      return {
        ...state,
        lists: action.payload,
      };
    case GET_LIST_APPROVAL_SK:
      return {
        ...state,
        lists: action.payload,
      };
    case GET_DASHBOARD_SK:
      return {
        ...state,
        dashboardSk: action.payload,
      };
    case GET_LIST_NEEDSIGN_SK:
      return {
        ...state,
        lists: action.payload,
      };
    case GET_OPTION_PYB:
      return {
        ...state,
        optionPYB: action.payload,
      };
    case GET_OPTION_PYB_PPID:
      return {
        ...state,
        optionPYBPPID: action.payload,
      };
    case GET_OPTION_PYB_PK:
      return {
        ...state,
        optionPYBPK: action.payload,
      };
    case GET_LIST_READY:
      return {
        ...state,
        lists: action.payload,
      };
    case GET_LIST_COMPLETED:
      return {
        ...state,
        lists: action.payload,
      };
    case GET_LIST_NUMBER:
      return {
        ...state,
        lists: action.payload,
      };
    case GET_LIST_REVISION:
      return {
        ...state,
        lists: action.payload,
      };
    case GET_REJECTED_DIGISIGN:
      return {
        ...state,
        lists: action.payload,
      };
    case GET_REVISI_DIGISIGN:
      return {
        ...state,
        lists: action.payload,
      };
    case GET_SIGNED_DIGISIGN:
      return {
        ...state,
        lists: action.payload,
      };
    case GET_RETRY_DIGISIGN:
      return {
        ...state,
        lists: action.payload,
      };
    case GET_DETAIL_DIGISIGN:
      return {
        ...state,
        detail: action.payload,
      };
    case GET_LIST_COURSE_DIGISIGN:
      return {
        ...state,
        courses: action.payload,
      };
    case ADD_DOCUMENT_DIGISIGN:
      return {
        ...state,
      };
    case ADD_ATTACHMENT_DIGISIGN:
      return {
        ...state,
        attachment: [...state.attachment, action.payload],
      };
    case DELETE_ATTACHMENT_DIGISIGN:
      return {
        ...state,
        attachment: action.payload,
      };
    case ONCHANGE_STATE_FILTER:
      return {
        ...state,
        filter: action.payload,
      };
    case GET_SUMMARY_COUNT:
      return {
        ...state,
        summaryCount: action.payload,
      };
    case GET_SUMMARY_LIST:
      return {
        ...state,
        summaryList: action.payload,
      };
    case GET_SUBJECT_LIST:
      return {
        ...state,
        subjectList: action.payload,
      };
    case RESET_DIGISIGN:
      return {
        ...state,
        draft: null,
        detail: null,
        lists: null,
        courses: null,
        detailCourse: null,
        filter: 'composer',
        attachment: [],
        summaryCount: null,
        summaryList: null,
        subjectList: null,
        templateList: null,
        optionPYB: [],
        listPenerimaSertif: [],
        listSertifikatExternal: null,
        detailSertifikatExternal: null,
        perizinanEseaCount: null,
        nomorPerizinan: '',
        perizinanPKRLCount: null,
        perizinanPKRLDashboard: null,
        siapMutuCount: null,
        monitoringDashboard: null,
        digisignCount: {
          need_sign: 0,
          done: 0
        }
      };
    case GET_TEMPLATE_DIGISIGN:
      return {
        ...state,
        templateList: action.payload,
      };
    case GET_PENERIMA_SERTIF_DIGISIGN:
      return {
        ...state,
        listPenerimaSertif: action.payload,
      };
    case GET_DETAIL_COURSE_DIGISIGN:
      return {
        ...state,
        detailCourse: action.payload,
      };
    case DELETE_DETAIL_COURSE_DIGISIGN:
      return {
        ...state,
        detailCourse: null,
      };
    case GET_SERTIFIKAT_EXTERNAL:
      return {
        ...state,
        listSertifikatExternal: action.payload,
      };
    case GET_DETAIL_SERTIFIKAT_EXTERNAL:
      return {
        ...state,
        detailSertifikatExternal: action.payload,
      };
    case GET_PERIZINAN_ESEA_COUNT:
      return {
        ...state,
        perizinanEseaCount: action.payload,
      };
    case GET_PENOMORAN_PERIZINAN:
      return {
        ...state,
        nomorPerizinan: action.payload,
      };
    case DELETE_PENOMORAN_PERIZINAN:
      return {
        ...state,
        nomorPerizinan: '',
      };
    case GET_TRACK_DIGISIGN:
      return {
        ...state,
        lists: action.payload,
      };
    case GET_PERIZINAN_PKRL_COUNT:
      return {
        ...state,
        perizinanPKRLCount: action.payload,
      };
    case GET_PERIZINAN_PKRL_DASHBOARD:
      return {
        ...state,
        perizinanPKRLDashboard: action.payload,
      };
    case GET_MONITORING_DASHBOARD:
      return {
        ...state,
        monitoringDashboard: action.payload.result,
      };
    case GET_LIST_DOKUMEN_LPMUKP: {
      return {
        ...state,
        lists: action.payload
      }
    };
    case GET_DETAIl_DOKUMEN_LPMUKP: {
      return {
        ...state,
        detail: action.payload
      }
    };
    case CHANGE_FILTER_PLPMUKP: {
      return {
        ...state,
        filterProdukLPMUKP: action.payload
      }
    }
    case GET_DASHBOARD_COUNT_DOKUMEN: {
      let result = action.payload.result
      let { tmpResult, count, tmpCompare } = getChartData(result)

      return {
        ...state,
        dokumenDashboard: {
          count: count,
          dataChart: tmpResult,
          dataCompare: tmpCompare
        }
      }
    }
    case GET_DIGISIGN_COUNT: {
      return {
        ...state,
        digisignCount: action.payload
      }
    }
    case RESET_LIST_RECEIVERS_DIGISIGN:
      return {
        ...state,
        listPenerimaSertif: [],
      };
    case ADD_CSV_TO_JSON_DIGISIGN:
      return {
        ...state,
        listPenerimaSertif: action.payload,
      };
    case GET_SIAPMUTU_COUNT:
      return {
        ...state,
        siapMutuCount: action.payload,
      };
    case GET_TEMPLATE_RECEIVERS_BANKOM:
      return {
        ...state,
        templateReceiversBankom: action.payload,
      };
    default:
      return {
        ...state,
      };
  }
};

const getChartData = (result) => {
  // State
  const appName = {
    'dokumen_lain': 'Dokumen Lain',
    'pkrl': 'Perizinan Lain',
    'esea': 'PKRL',
    'dokumen_sk': 'Dokumen SK',
    'dokumen_pk': 'Dokumen PK PPPK'
  }
  let tmpCompare = []
  let tmpResult = []
  let count = {
    belumDiproses: 0,
    sedangDiproses: 0,
    sudahDiproses: 0,
    percentDraft: 0,
    percentInProgress: 0,
    percentDone: 0,
  }
  // Assign count and percentage value
  count.belumDiproses = result?.total_percent || 0
  count.sudahDiproses = result?.total_done || 0
  count.sedangDiproses = result.total_in_progress || 0
  count.percentDraft = result?.percent_draft || 0
  count.percentInProgress = result.percent_in_progress || 0
  count.percentDone = result?.percent_done || 0
  // Compute data for bar diagram data and compare bar data
  Object.keys(result).map((key) => {
    if (key !== 'percent_done' && key !== 'total_done' && key !== 'percent_in_progress' && key !== 'total_in_progress' && key !== 'percent_draft' && key !== 'total_percent') {
      let data = result[key]
      let totalDone = data.total_done
      let totalInProgress = data.total_in_progress
      let totalDocument = totalDone + totalInProgress

      let compareObj = {
        'name': appName[key],
        'donePercentage': totalDocument === 0 ? 0 : (totalDone / totalDocument) * 100 === 0 ? 0 : `${((totalDone / totalDocument) * 100).toFixed(1)}%`,
        'inProgressPercentage': totalDocument === 0 ? 0 : (totalInProgress / totalDocument) * 100 === 0 ? 0 : `${((totalInProgress / totalDocument) * 100).toFixed(1)}%`,
      }
      let tmp = {
        'name': appName[key],
        'jumlah': totalDone,
        'children': Object.keys(result[key]).filter(child => typeof data[child] === 'object').map((child) => {
          let tmpJumlahDone = 0
          let tmpJumlahInprogress = 0

          for (let i = 0; i < data[child].data?.length; i++) {
            tmpJumlahDone += data[child].data[i].done_count
            tmpJumlahInprogress += data[child].data[i].in_progress_count
          }

          return {
            'name': child,
            'jumlah_done': tmpJumlahDone,
            'jumlah_inprogress': tmpJumlahInprogress,
          }
        })
      }
      tmpResult.push(tmp)
      tmpCompare.push(compareObj)
    }
  })

  return {
    count,
    tmpResult,
    tmpCompare,
  }

}

export default digitalSignReducer;
